// extracted by mini-css-extract-plugin
export default {"hidden":"hidden--HqULb"};